import React from "react";
import {
  Breadcrumb,
  ChatBubbleLeftRightIcon,
  ErrorAlert,
  LinkBtn,
  PageHero,
  TableRowsPerPage,
} from "@";
import SearchToggle from "@/shared/components/buttons/SearchToggle";
import { DataTable } from "@/shared/components/tanstackTable";
import { useWhatsappCampaignPage } from "../hooks";
import { CampaignsMultiSearch } from "../components";

const Page: React.FC = () => {
  const {
    data,
    columns,
    isLoading,
    error,
    totalItems,
    search,
    updateSearch,
    applySearch,
    resetSearch,
    pg,
    updatePg,
    refetch,
  } = useWhatsappCampaignPage();

  return (
    <>
      <ErrorAlert reload={refetch} show={error} />
      <Breadcrumb links={[{ name: "حملات WhatsApp", link: "" }]} />

      <main className="table-card relative">
        <PageHero
          eyebrow="التسويق / واتساب"
          title="حملات WhatsApp"
          count={totalItems}
          icon={ChatBubbleLeftRightIcon}
          hideCount={isLoading}
        >
          <TableRowsPerPage
            pagination={{ ...pg, rows: totalItems }}
            rowsPerPageOptions={[5, 10, 15, 25]}
            onRowsPerPageChange={(size: number) => updatePg({ size, page: 1 })}
          />

          <SearchToggle
            toggle={() => updateSearch({ show: !search.show })}
            children={null}
          />

          <LinkBtn to="/whatsapp-campaign/create" create />
        </PageHero>

        <CampaignsMultiSearch
          search={search}
          updateSearch={updateSearch}
          onSubmit={applySearch}
          onReset={resetSearch}
        />

        <DataTable
          data={data}
          columns={columns}
          isLoading={isLoading}
          pagination={{ ...pg, rows: totalItems }}
          onPageChange={(page: number) => updatePg({ page })}
          onPageSizeChange={(size: number) => updatePg({ size, page: 1 })}
        />
      </main>
    </>
  );
};

export default Page;
